import { Component, OnInit } from '@angular/core';
import { CommonService  } from '../../services/common.service';
import { AuthenticationService } from '../../services/authentication.service';
import { FormBuilder, Validators, FormGroup, FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-register-form',
  templateUrl: './register-form.component.html',
  styleUrls: ['./register-form.component.scss']
})
export class RegisterFormComponent implements OnInit {

    public show: boolean = false;
    phoneDisabled: boolean = false;
    emailDisabled: boolean = false;
    firstNameDisabled: boolean = false;
    lastNameDisabled: boolean = false;


    terms: boolean = false;
    email_exist_message: boolean = false;

    options!: any[];
    filteredOptions!: Observable<any>;
    selectedOrganization!: any;

    myControl = new FormControl();
    mobileLoginForm = new FormGroup({
        phone: new FormControl("", [Validators.required])
    });


    userRegistrationObj: any = {
        organization: {
            name: "",
            id: ""
        },
        mobileNumber: { number: "", countryCode: "", dialCode: "" },
        firstName: "",
        lastName: "",
        emailAddress: ""
    };

    constructor(public common: CommonService,
        public authenticationService: AuthenticationService,
        private _activatedRoute: ActivatedRoute,
        private router: Router    ) { }

    ngOnInit() {
        debugger;
        if (this.authenticationService._loginData.loginType == "") {
            this.router.navigate(["/auth/login"]);
        }
        else {
            this.getAllAccounts();
            if (this.authenticationService._loginData.loginType == "mobile") {
                this.mobileLoginForm.setValue({ "phone": this.authenticationService._loginData.mobile });
                this.phoneDisabled = true;
            }
            else if (this.authenticationService._loginData.loginType == "email") {
                this.userRegistrationObj.emailAddress = this.authenticationService._loginData.email;
                this.emailDisabled = true;
            }
            else if (this.authenticationService._loginData.loginType == "linkedin") {
                this.userRegistrationObj.firstName = this.authenticationService._loginData.firstName;
                this.userRegistrationObj.lastName = this.authenticationService._loginData.lastName;
                this.userRegistrationObj.emailAddress = this.authenticationService._loginData.email;
                this.emailDisabled = true;
                this.firstNameDisabled = true;
                this.lastNameDisabled = true;
            }
            else if (this.authenticationService._loginData.loginType == "google") {
                this.userRegistrationObj.firstName = this.authenticationService._loginData.firstName;
                this.userRegistrationObj.emailAddress = this.authenticationService._loginData.email;
                this.emailDisabled = true;
            }
        }
    }



    formValidation(): boolean {

        if (this.selectedOrganization != undefined) {
            if (this.selectedOrganization["Name"] == this.userRegistrationObj.organization.name) {
                //this means that the user select organization from the list
                this.userRegistrationObj.organization.id = this.selectedOrganization["Id"];
            }
            else {
                this.userRegistrationObj.organization.id = "";
            }
        }


        if (this.userRegistrationObj.firstName === "" || this.userRegistrationObj.lastName === "") {
            this.common.ShowMessage("error", "First and Last name are mandatory", "");
            return false;
        }

        var emailValidation = this.common.ValidateEmail(this.userRegistrationObj.emailAddress);
        if (!emailValidation.valid) {
            this.common.ShowMessage("error", emailValidation.message, "");
            return false;
        }

        if (this.mobileLoginForm.value.phone != null) {
            this.userRegistrationObj.mobileNumber.number = this.mobileLoginForm.value.phone;
            //this.userRegistrationObj.mobileNumber.countryCode = this.registerForm.value.phone.countryCode;
            //this.userRegistrationObj.mobileNumber.dialCode = this.registerForm.value.phone.dialCode;
        }
        else {
            this.common.ShowMessage("error", "Mobile Number is mandatory", "");
            return false;
        }

        if (this.userRegistrationObj.organization.name === "") {
            this.common.ShowMessage("error", "Organization name are mandatory", "");
            return false;
        }

        if (!this.terms) {
            this.common.ShowMessage("error", "Accept terms and condition to proceed", "");
            return false;
        }
        return true;
    }
    register() {

        var pform = this.mobileLoginForm;
        if (this.formValidation()) {
            console.log("Web/Account/Register/UserRegistrationObject", this.userRegistrationObj);
            var obj = {
                "EMail": this.userRegistrationObj.emailAddress,
                "Password": "",
                "firstName": this.userRegistrationObj.firstName,
                "lastName": this.userRegistrationObj.lastName,
                "mobileNumber": this.userRegistrationObj.mobileNumber.number,
                "organization": this.userRegistrationObj.organization.name,
                "organizationId": this.userRegistrationObj.organization.id,
                "mobileCountryCode": this.userRegistrationObj.mobileNumber.dialCode,
                "country": this.userRegistrationObj.mobileNumber.countryCode
            };
            debugger;
            this.authenticationService._register(obj).subscribe(
                (res: any) => {

                    //console.log("Web/Account/Register/register()", res);
                    if (res.registerResponce == 1) //means the email already exists
                        this.email_exist_message = true;
                    else if (res.registerResponce == 2) {
                        //this.common.ShowMessage("info", "you have successfully registered in mygistec portal. please proceed to login", "");
                        //this.router.navigate(["/auth/login"]);
                        this.login(res.user);
                    }

                    this.userRegistrationObj.password = "";
                },
                (err: any) => {
                    console.error("Web/Account/Register/register()", err);
                }
            );

        }



    }
    login(userData: any) {

        //generate token

        let authorizationData: any = {
            id: userData.id,
            token: '',
            userName: userData.eMail,
            refreshToken: "",
            useRefreshTokens: false,
            isAuth: true,
            mobileNumber: userData.mobilePhone
        };

        this.authenticationService._setLocalStorage("authorizationUserData", JSON.stringify(userData));
        this.authenticationService._setLocalStorage("authorizationData", JSON.stringify(authorizationData));
        this.authenticationService._authentication = authorizationData;
        this.authenticationService.userData = userData;

        //TODO: Pass the user ID
        //this.authenticationService._addUserLogin();

        this.getUserIpLocation();

        var returnUrl = this._activatedRoute.snapshot.queryParams['returnUrl'] || '/';
        if (returnUrl != "/")
            this.router.navigate([returnUrl]);
        else {
            this.router.navigate(['/home/news-feed']);
            //this.router.navigate(['/articles/all']);
        }

    }
    getUserIpLocation() {
        this.authenticationService.getUserIpLocation().subscribe(
            (res: any) => {
                //TODO: Check the output of the service - the below line
                //this.rootScope.userAddress = res;
                console.log(res);
            },
            (err: any) => {
                console.error("getUserIpLocation", err);
            })
    }
    private getAllAccounts() {
        this.authenticationService._getAllAccounts().subscribe((res: any) => {
            //console.log('Web/Register/getAllAccounts()', res);
            this.options = res;
            this.filteredOptions = this.myControl.valueChanges.pipe(
                startWith(''),
                map((value: string) => this._filter(value)),
            );
        }, (err: any) => {
            console.error("Web/Register/getAllAccounts()", err);
        });
    }
    private _filter(value: string): string[] {
        const filterValue = value.toLowerCase();
        return this.options.filter(option => option.Name.toLowerCase().includes(filterValue));
    }
    getSelectedOrganization(option: any) {
        //console.log("Web/Account/Register/getSelectedOrganization", option);
        this.selectedOrganization = option;
    }

    showPassword() {
        this.show = !this.show;
    }
    
}
